(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drako-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (root.dataset.sliderInit === '1') return;
    root.dataset.sliderInit = '1';

    var viewport = root.querySelector('[data-viewport]');
    var track = viewport && viewport.querySelector('.drako-cats__track');
    if (!viewport || !track) return;

    var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var loopSeconds = parseFloat(root.dataset.scrollSpeed) || 45;
    var halfWidth = 0;
    var pxPerSecond = 0;
    var pos = 0;
    var paused = prefersReduce;
    var resumeTimer;
    var lastTs = 0;

    function measure() {
      halfWidth = track.scrollWidth / 2;
      pxPerSecond = halfWidth / loopSeconds;
      if (viewport.scrollLeft >= halfWidth) viewport.scrollLeft -= halfWidth;
      pos = viewport.scrollLeft;
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (!paused && halfWidth > 0) {
        pos += pxPerSecond * dt;
        if (pos >= halfWidth) pos -= halfWidth;
        viewport.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    }

    function pauseTemporarily(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        if (!prefersReduce) paused = false;
        pos = viewport.scrollLeft;
      }, ms);
    }

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });
    measure();
    requestAnimationFrame(tick);
    window.addEventListener('resize', measure);

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () {
      if (prefersReduce) return;
      pos = viewport.scrollLeft;
      paused = false;
    });
    viewport.addEventListener('focusin', function () { paused = true; });
    viewport.addEventListener('focusout', function () {
      if (prefersReduce) return;
      pos = viewport.scrollLeft;
      paused = false;
    });
    viewport.addEventListener('scroll', function () {
      if (paused) pos = viewport.scrollLeft;
    });

    root.querySelectorAll('[data-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.drako-cat');
        var step = card ? card.getBoundingClientRect().width + 24 : 300;
        pauseTemporarily(4000);
        viewport.scrollBy({ left: btn.dataset.arrow === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cat-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // The thumbnail rail is clipped to the main image, so flag it while more shots
  // sit below the fold. CSS turns that into the fade + chevron cue.
  (function () {
    function sync(rail) {
      var list = rail.querySelector('.thumbnail-list');
      if (!list) return;
      var more = list.scrollHeight - list.scrollTop - list.clientHeight > 8;
      if (more) {
        rail.setAttribute('data-more', '');
      } else {
        rail.removeAttribute('data-more');
      }
    }

    // Media filenames carry the colour ("…-silver-1.jpg"), so when a colour is
    // picked the rail shows only that colour's views plus the generic shots.
    // A file naming several colours goes to the one naming the most tokens
    // ("blue-white" is Blue/White, not White); ambiguous files stay visible.
    function tokens(value) {
      return value.toLowerCase().split(/[\s/&+-]+/).filter(Boolean);
    }

    function colourFieldset(scope) {
      var sets = scope.querySelectorAll('variant-selects fieldset, variant-radios fieldset');
      for (var i = 0; i < sets.length; i++) {
        var legend = sets[i].querySelector('legend');
        if (legend && /^\s*colou?r\b/i.test(legend.textContent)) return sets[i];
      }
      return null;
    }

    // Fallback colour signal for products whose media filenames carry no
    // colour tokens (e.g. "DKBS40-4-copy.jpg" on the Leather Boxing Gloves,
    // Ian 2026-08-20): each colour's ASSIGNED variant image is known data, so
    // a media file matching another colour's variant image is that colour's.
    // colourAnchors: lowercased filename -> colour value (null = ambiguous).
    var colourAnchors = null;
    function loadColourAnchors(cb) {
      colourAnchors = {}; // set now so init() never double-fetches
      var m = location.pathname.match(/\/products\/[^\/?]+/);
      if (!m) return;
      fetch(m[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var ci = -1;
        (p.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : (o.name || '');
          if (/colou?r/i.test(n)) ci = i;
        });
        if (ci === -1) return;
        var anchors = {};
        (p.variants || []).forEach(function (v) {
          if (!v.featured_image || !v.featured_image.src) return;
          var f = decodeURIComponent(v.featured_image.src.split('/').pop().split('?')[0]).toLowerCase();
          var col = v.options[ci];
          if (!(f in anchors) || anchors[f] === col) anchors[f] = col;
          else anchors[f] = null; // shared by several colours - unusable
        });
        colourAnchors = anchors;
        if (cb) cb();
      }).catch(function () {});
    }

    function classify(fname, colours) {
      // Partial names count ("blue-1.jpg" is the Blue/White view when no plain
      // Blue exists): score each colour by the fraction of its tokens present,
      // break ties by absolute token count, and bail out if still tied.
      var scored = colours
        .map(function (c) {
          var t = tokens(c);
          var hit = t.filter(function (x) { return fname.indexOf(x) !== -1; }).length;
          return { c: c, hit: hit, frac: hit / t.length };
        })
        .filter(function (s) { return s.hit > 0; });
      if (!scored.length) return null;
      scored.sort(function (a, b) { return b.frac - a.frac || b.hit - a.hit; });
      if (scored.length > 1 && scored[1].frac === scored[0].frac && scored[1].hit === scored[0].hit) {
        return null;
      }
      return scored[0].c;
    }

    // Ian (2026-08-20): the selected colour's shots must lead, not just survive
    // the filter. Stable partition — selected colour first, generic/ambiguous
    // next, other colours last; original order kept within each group (Dawn
    // re-renders the gallery on variant change, so idx is pristine each pass).
    // hide=true also display:nones the other colours (the desktop rail);
    // hide=false only reorders (the mobile swipe carousel keeps every slide).
    function orderByColour(listEl, items, selected, colours, hide) {
      var shown = 0;
      var entries = [];
      items.forEach(function (item, idx) {
        var img = item.querySelector('img');
        var cls = null;
        if (img) {
          var src = img.currentSrc || img.src || '';
          var fname = decodeURIComponent(src.split('/').pop().split('?')[0]).toLowerCase();
          cls = classify(fname, colours);
          if (cls === null && colourAnchors) {
            var anchored = colourAnchors[fname];
            if (anchored && colours.indexOf(anchored) !== -1) cls = anchored;
          }
          if (cls === null) {
            // last resort: an image whose ALT text exactly equals a colour
            // value belongs to that colour. Lets Ian tag images from the
            // admin (media alt = "Pink") without renaming files.
            var alt = (img.alt || '').trim().toLowerCase();
            if (alt) {
              for (var ai = 0; ai < colours.length; ai++) {
                if (colours[ai].toLowerCase() === alt) { cls = colours[ai]; break; }
              }
            }
          }
        }
        var away = cls !== null && cls !== selected;
        if (hide) {
          item.style.display = away ? 'none' : '';
          if (!away) shown++;
        }
        entries.push({ item: item, rank: away ? 2 : (cls === selected ? 0 : 1), idx: idx });
      });
      if (hide && shown === 0) {
        items.forEach(function (item) { item.style.display = ''; });
        return;
      }
      entries.sort(function (a, b) { return a.rank - b.rank || a.idx - b.idx; });
      entries.forEach(function (e) { listEl.appendChild(e.item); });
    }

    function applyColourFilter(section) {
      var fieldset = colourFieldset(section);
      if (!fieldset) return;
      var colours = Array.prototype.map.call(
        fieldset.querySelectorAll('input[type="radio"]'), function (i) { return i.value; });
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked || colours.length < 2) return;
      var selected = checked.value;
      var rail = section.querySelector('media-gallery .thumbnail-slider');
      if (rail) {
        var list = rail.querySelector('.thumbnail-list');
        if (list) {
          // Ian (2026-09-10): keep every colour in the desktop rail, do not hide the
          // others — the selected colour's shots lead, the rest follow below. hide=false
          // reorders without display:none (was true = hide others, his earlier ask).
          orderByColour(list, rail.querySelectorAll('.thumbnail-list__item'), selected, colours, false);
        }
        sync(rail);
      }
      var mediaList = section.querySelector('media-gallery .product__media-list');
      if (mediaList) {
        orderByColour(mediaList, mediaList.querySelectorAll('.product__media-item'), selected, colours, false);
      }
    }

    function init() {
      document.querySelectorAll('media-gallery .thumbnail-slider').forEach(function (rail) {
        if (rail.dataset.moreInit === '1') return;
        rail.dataset.moreInit = '1';
        var list = rail.querySelector('.thumbnail-list');
        if (!list) return;
        var update = function () { sync(rail); };
        list.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        // images load late and change scrollHeight
        list.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', update, { once: true });
        });
        update();
      });

      if (colourAnchors === null) {
        loadColourAnchors(function () {
          document.querySelectorAll('product-info').forEach(function (s) { applyColourFilter(s); });
        });
      }

      document.querySelectorAll('product-info').forEach(function (section) {
        var run = function () { applyColourFilter(section); };
        if (section.dataset.colourFilterInit !== '1') {
          section.dataset.colourFilterInit = '1';
          section.addEventListener('change', function (e) {
            if (e.target && e.target.matches('variant-selects input, variant-radios input')) {
              // Dawn swaps gallery markup after a variant change; filter after it settles
              setTimeout(run, 350);
            }
          });
          section.querySelectorAll('media-gallery .thumbnail-list img').forEach(function (img) {
            if (!img.complete) img.addEventListener('load', run, { once: true });
          });
        }
        run();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
